import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *章节列表
 * @param params
 * 
*/

export const chapterList = params => Http.get(`${baseUrl}/chapter`, { params })


/**
 *章节详情
 * @param classChapterId
 * 
*/

export const chapterInfo = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}` )

/**
 *章节ppt
 * @param classChapterId
 * 
*/

export const chapterPPT = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}/ppt` )

/**
 *章节测验
 * @param classChapterId
 * 
*/

export const chapterTest = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}/test` )

/**
 *提交测验
 * @param params
 * 
*/

export const submitTest = params => Http.post(`${baseUrl}/chapter/${params.classChapterId}/test`, params.answers )

/**
 *学情统计
 * @param classChapterId
 * 
*/

export const chapterStatistics = classChapterId => Http.get(`${baseUrl}/statistics/xq/${classChapterId}`)
